module.exports = __webpack_public_path__ + "static/media/dollar-2-rocklea.f65c859d.png";